import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=24f178bc&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=24f178bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f178bc",
  null
  
)

export default component.exports